import {createSvgIcon} from '../create-svg-icon';

export const FlagIcon = createSvgIcon(
  <path d="m14 6-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z" />
, 'OutlinedFlagOutlined');
